import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { HelpersService } from '../../services/helpers.service';

@Component({ standalone: false,
  selector: 'vfa-cp-consents-dialog',
  templateUrl: './consents-dialog.component.html',
  styleUrls: ['./consents-dialog.component.scss']
})
export class ConsentsModal implements OnInit {

  constructor(private dialog: MatDialog, 
              @Inject(MAT_DIALOG_DATA) private data: any, 
              private helpersService: HelpersService) {}

  ngOnInit(): void {
  }

  public closeModal() {
    const state = this.data.state;
    let data = this.data.data;
    data.consentsIds = this.data.consentsIds;
    this.helpersService.consentsIds = this.data.consentsIds;
    this.helpersService.putUserState(state, data).subscribe(res => {
      this.dialog.closeAll();
    }, err => {
      this.dialog.closeAll();
    })
  }

}

